import React, { useEffect, useState, useRef } from "react";
import { Box, Paper, useTheme, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../components/PageTitle";
import CustomPlaylistToolbar from "./Components/PlaylistsDataGrid/CustomPlaylistToolbar";
import PlaylistDataGrid from "./Components/PlaylistsDataGrid/PlaylistDataGrid";
import { fetchPlaylists } from "../../store/Playlists/playlistsThunks";

function Playlists() {
  const dispatch = useDispatch();
  const playlists = useSelector((state) => state.playlists.playlists);
  const loading = useSelector((state) => state.playlists.loading);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const gridApiRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    dispatch(fetchPlaylists({ search: searchQuery }));
  }, [dispatch, searchQuery]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    dispatch(fetchPlaylists({ search: query }));
  };

  const handleRefresh = () => {
    dispatch(fetchPlaylists({ search: searchQuery }));
  };

  const handleFilterClick = () => {
    if (gridApiRef.current) gridApiRef.current.showFilterPanel();
  };

  const handleColumnClick = () => {
    if (gridApiRef.current) gridApiRef.current.showPreferences("columns");
  };

  return (
    <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      height: "100%",
      maxHeight: "100vh",
      overflow: "hidden",
      backgroundColor: (theme) => theme.palette.background.default,
    }}
    >
      {/* Fixed header section */}
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          p: isSmallScreen ? 1 : 1.5,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: isSmallScreen ? "flex-start" : "center",
            justifyContent: "space-between",
            gap: isSmallScreen ? 2 : 0,
          }}
        >
          <PageTitle
            title="Playlists"
            subtitle="View and manage all playlists in the system"
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              alignItems: isSmallScreen ? "stretch" : "center",
              gap: 2,
              width: isSmallScreen ? "100%" : "auto",
            }}
          >
            <CustomPlaylistToolbar
              onSearch={handleSearch}
              searchQuery={searchQuery}
              onRefresh={handleRefresh}
              onFilterClick={handleFilterClick}
              onColumnClick={handleColumnClick}
              isSmallScreen={isSmallScreen}
            />
          </Box>
        </Box>
      </Box>

      {/* Content section */}
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          position: "relative",
          height: "calc(100vh - 120px)",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: "auto",
            "& .MuiDataGrid-root": {
              border: "none",
              backgroundColor: (theme) => theme.palette.background.paper,
              padding: 0,
              margin: 0,
            },
          }}
        >
          <PlaylistDataGrid
            data={playlists}
            loading={loading}
            searchQuery={searchQuery}
            onSearch={handleSearch}
            apiRef={gridApiRef}
          />
        </Paper>
      </Box>
    </Box>
  );
}

export default Playlists;
